import { recentSearchQueryKeys as e } from "./useRecentSearchQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { recentSearchesApi as r } from "@maat/api-main";
//#region src/recentSearches/useRecordRecentSearchMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.record(e),
		retry: !1,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useRecordRecentSearchMutation };
